/** Create Task dialog state */ export var TaskCreationState = /*#__PURE__*/ function(TaskCreationState) {
    /** Shows Create Task Process is not started. */ TaskCreationState["NotStarted"] = "NotStarted";
    /** Shows Create Task Process is in progress. */ TaskCreationState["InProgress"] = "InProgress";
    /** Shows Create Task Process is completed. */ TaskCreationState["Completed"] = "Completed";
    /** Shows Create Task Process in failed. */ TaskCreationState["Failed"] = "Failed";
    return TaskCreationState;
}({});
